const baseUrl = "/audit"

// GET
export const GET_ACTION_TYPES = baseUrl + "/actionTypes"
export const GET_LIST_USERS = baseUrl + "/listUsers/:q"
export const GET_ACTIONS_LIST = baseUrl + "/actions"

// POST
export const POST_FILTER_RASTREIO = baseUrl + "/"
